// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-flex {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  background: white;
  height: 100vh;
}
.reset-flex .tvs-logo img {
  max-width: 100%;
  height: auto;
  margin-top: 32px;
}
.reset-flex .reset-password-form {
  max-width: 450px;
  width: 100%;
  padding: 50px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 6%;
  display: flex;
  flex-direction: column;
}
.reset-flex .reset-password-form div {
  margin-bottom: 15px;
  position: relative;
}
.reset-flex .reset-password-form label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  margin-top: 0.8rem !important;
  position: static;
}
.reset-flex .pass-icon {
  position: absolute;
  top: 62%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
}
.reset-flex .pass-icons {
  position: absolute;
  top: 73%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
}
.reset-flex .reset-password-form input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}
.reset-flex .error-message {
  color: #ff0000;
  margin-bottom: 15px;
}
.reset-flex .validation-text {
  margin-bottom: 16px;
  font-size: 12px;
  text-align: justify;
}
.reset-flex .reset-password-form button {
  padding: 10px 15px;
  border: none;
  cursor: pointer;
  width: auto;
  height: 50px;
  border-radius: 5px;
  background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);
  font-family: "Poppins";
  font-size: 18px;
  color: #ffffff;
}
.reset-flex .reset-password-form button:disabled {
  background: #7297be !important;
}
.reset-flex .reset-password-form button:hover {
  background-color: #0056b3;
}`, "",{"version":3,"sources":["webpack://./src/component/resetpassword/resetpassword.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;AACF;AACE;EACE,eAAA;EACA,YAAA;EACA,gBAAA;AACJ;AAEE;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wCAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AAAJ;AAGE;EACE,mBAAA;EACA,kBAAA;AADJ;AAIE;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBAAA;AAFJ;AAKE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,eAAA;AAHJ;AAME;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,eAAA;AAJJ;AAOE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;AALJ;AAQE;EACE,cAAA;EACA,mBAAA;AANJ;AASE;EACE,mBAAA;EACA,eAAA;EACA,mBAAA;AAPJ;AAUE;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mEAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;AARJ;AAWE;EACE,8BAAA;AATJ;AAYE;EACE,yBAAA;AAVJ","sourcesContent":[".reset-flex {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  padding: 20px;\r\n  background: white;\r\n  height: 100vh;\r\n\r\n  .tvs-logo img {\r\n    max-width: 100%;\r\n    height: auto;\r\n    margin-top: 32px;\r\n  }\r\n\r\n  .reset-password-form {\r\n    max-width: 450px;\r\n    width: 100%;\r\n    padding: 50px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 8px;\r\n    background-color: #fff;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    margin-top: 6%;\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .reset-password-form div {\r\n    margin-bottom: 15px;\r\n    position: relative;\r\n  }\r\n\r\n  .reset-password-form label {\r\n    display: block;\r\n    margin-bottom: 8px;\r\n    font-weight: bold;\r\n    margin-top: 0.8rem!important;\r\n    position: static;\r\n  }\r\n\r\n  .pass-icon {\r\n    position: absolute;\r\n    top: 62%;\r\n    right: 10px;\r\n    transform: translateY(-50%);\r\n    cursor: pointer;\r\n  }\r\n\r\n  .pass-icons {\r\n    position: absolute;\r\n    top: 73%;\r\n    right: 10px;\r\n    transform: translateY(-50%);\r\n    cursor: pointer;\r\n  }\r\n\r\n  .reset-password-form input {\r\n    width: 100%;\r\n    padding: 10px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .error-message {\r\n    color: #ff0000;\r\n    margin-bottom: 15px;\r\n  }\r\n\r\n  .validation-text {\r\n    margin-bottom: 16px;\r\n    font-size: 12px;\r\n    text-align: justify;\r\n  }\r\n\r\n  .reset-password-form button {\r\n    padding: 10px 15px;\r\n    border: none;\r\n    cursor: pointer;\r\n    width: auto;\r\n    height: 50px;\r\n    border-radius: 5px;\r\n    background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);\r\n    font-family: \"Poppins\";\r\n    font-size: 18px;\r\n    color: #ffffff;\r\n  }\r\n\r\n  .reset-password-form button:disabled {\r\n    background: #7297be !important;\r\n  }\r\n\r\n  .reset-password-form button:hover {\r\n    background-color: #0056b3;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
